const T = {
  VARIANTS_GET_START: 'ott/cars/variantsGetStart',
  VARIANTS_GET_SUCCESS: 'ott/cars/variantsGetSuccess',
  VARIANTS_GET_FAIL: 'ott/cars/variantsGetFail',
  VARIANTS_GET_RESET: 'ott/cars/variantsGetReset',

  VARIANTS_NOTIFY_OF_EMPTY_RATES: 'ott/cars/variantsNotifyOfEmptyRates',

  FILTER_APPLY: 'ott/cars/filterApply',

  BONUS_CURRENCY_SET: 'ott/cars/wl/bonusCurrencySet',
};

export default T;
